import { APPLE_EMAIL_HAS_ACCOUNT, APPLE_SIGN_IN_WAITLISTED } from "@/types/appleSignIn.ts";
import {
  SLACK_ALREADY_CONNECTED,
  TEAMS_ADMIN_CONSENT_PATH,
  TEAMS_ALREADY_CONNECTED,
  TEAMS_CONSENT_DENIED,
} from "@/types/connectors.ts";
import { SLACK_EMAIL_HAS_ACCOUNT } from "@/types/slackSignIn.ts";

/**
 * Copy for a connect-failure code that needs to say more than "try again".
 * Undefined means the caller shows its own generic copy.
 */
export function connectErrorCopy(code: string | null | undefined): string | undefined {
  if (code === SLACK_ALREADY_CONNECTED) {
    return "That Slack account is already connected to another Okthx account. Disconnect it there first.";
  }
  if (code === TEAMS_ALREADY_CONNECTED) {
    return "That Teams account is already connected to another Okthx account. Disconnect it there first.";
  }
  if (code === TEAMS_CONSENT_DENIED) {
    return "Microsoft didn't grant Okthx access to Teams. If your organization requires admin approval, send your IT admin the approval link, then connect again.";
  }
  if (code === SLACK_EMAIL_HAS_ACCOUNT) {
    return "You already have an Okthx account with this email. Sign in the way you did before, then connect Slack from Connectors.";
  }
  if (code === APPLE_EMAIL_HAS_ACCOUNT) {
    return "You already have an Okthx account with this email. Sign in the way you did before.";
  }
  if (code === APPLE_SIGN_IN_WAITLISTED) {
    return "You're on the waitlist. We'll email you when there's room.";
  }
  return undefined;
}

/**
 * The approval link for a tenant admin, when `code` is one that needs it. The
 * link is fixed rather than taken from the result URL, so a crafted result page
 * can't put its own link in front of the user.
 */
export function connectErrorAdminLink(
  code: string | null | undefined,
  apiOrigin: string,
): string | undefined {
  return code === TEAMS_CONSENT_DENIED
    ? new URL(TEAMS_ADMIN_CONSENT_PATH, apiOrigin).toString()
    : undefined;
}
